import {Autocomplete, FormControlLabel, Grid, Paper, Switch, TextField, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SyntheticEvent, useContext, useEffect} from "react";
import {useState} from "react";
import {CHARGING_STATION_STATUS, CURRENT_ATTRIBUTE_DMS, CURRENT_STATUS_DMS, CUR_ATTR_BY_STATUS_DMS, CUR_STATUS_DMS} from "../../data";
import {FormAutocomplete, FormTextField} from "../../common/form-fields-wrappers";
import {Controller, FormProvider } from "react-hook-form";
import ActionFilters from "./ActionFilter";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

const mockDmsCategory = [
    'Car Rental',
    'Virtual',
    'Car Dealer',
    'Broker',
    'Repair shop',
    'Deposit provider',
    'Service',
    'Point Rélais',
];

const mockDmsType = [
    'Real',
    'Shuttle',
    'Dealer',
    'Temporary',
    'Implant c/o company',
    'DMS self public area',
    'DMS private area',
    'White label',
    'Meet & Greet/Virtual',
    'Site of interest'
];

const serviceTypeList = [
    'Long term',
    'Second-hand',
    'Long term vehicle delivery',
    'Long term vehicle collection',
    'Digital affiliation',
    'Procurer',
    'Long term special vehicles',
    'Short term special vehicles'
]

const isKeylessOptions = [
    'true',
    'false'
];

const DmsFilter = ({searchDmsForm, handleSearch, filterExpandedState}: any) => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);
    
    const [curAttributes, setCurAttributes] = useState<string[]>(CURRENT_ATTRIBUTE_DMS);

    const handleChangeStatus = (_e: SyntheticEvent, value: any) => {
        searchDmsForm.setValue('currentAttribute', '');
        const curStatus = value as (CUR_STATUS_DMS | undefined) || 'DEFAULT';
        // @ts-ignore
        setCurAttributes(CUR_ATTR_BY_STATUS_DMS[curStatus]);
    }

    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const legalEntities = globalData.user?.legalEntities;
    const [dealers, setDealers] = useState<any[]>([]);

    const {errors} = searchDmsForm.formState;

    return (
        <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
            <FormProvider {...searchDmsForm}>
                <form onSubmit={searchDmsForm.handleSubmit(handleSearch)}>
                    <Grid container columnSpacing={2}>
                            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                <FormTextField
                                    name={`name`}
                                    control={searchDmsForm.control}
                                    label={t('searchDms.form.label.dmsNaming')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                <FormAutocomplete
                                    name={"currentStatus"}
                                    control={searchDmsForm.control}
                                    label={t('searchDms.form.label.currentStatus')}
                                    fullWidth
                                    options={CURRENT_STATUS_DMS}

                                    getOptionLabel={(option: any) => option ? t(`searchDms.form.label.currentStatusValue.${option}`) : ''}
                                    onChange={handleChangeStatus}
                                />
                            </Grid>
                            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                <FormAutocomplete
                                    name="dmsType"
                                    control={searchDmsForm.control}
                                    label={t('searchDms.form.label.dmsType')}
                                    fullWidth
                                    options={mockDmsType}
                                    getOptionLabel={(option: any) => option ? option : ''}
                                />
                            </Grid>

                            <ActionFilters
                                filterExpandedState={filterExpandedState}
                                handleSearch={handleSearch}
                                searchDmsForm={searchDmsForm}
                                setCurAttributes={setCurAttributes}
                            />

                        </Grid>

                        {filterExpandedState[0] &&
                            <Grid container item xs={12} columnSpacing={2} sx={{mt: theme.spacing(2)}}>

                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name="dmsCategory"
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.dmsCategory')}
                                        multiple
                                        options={mockDmsCategory}
                                        getOptionLabel={(option: any) => option ? option : ''}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`identificationCode`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.dmsId')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`companyName`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.companyName')}
                                        fullWidth
                                    />
                                </Grid>

                                {legalEntities.length > 1 &&
                                    <Grid item md={3} xs={12}>
                                        <Controller
                                            control={searchDmsForm.control}
                                            name="tenants"
                                            render={({field: {onChange, value}}: any) => (
                                                <Autocomplete
                                                    limitTags={1}
                                                    disableCloseOnSelect={true}
                                                    multiple
                                                    id={'tenants'}
                                                    options={legalEntities}
                                                    value={value || []}
                                                    getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.name))}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                                    label={t("searchDms.form.label.legalEntities")}
                                                                    error={Boolean(errors?.tenants)}
                                                                    helperText={t(errors?.tenants?.message as string)}
                                                        />
                                                    )}
                                                    onChange={(event, value) => {
                                                        let tmpDealers = globalData.user?.dealers?.filter((dealer: any) => {
                                                            if (value?.length > 0) {
                                                                return value?.find((legalEntity: any) => legalEntity.id === dealer.legalEntities[0].id);
                                                            } else {
                                                                return dealer;
                                                            }
                                                        });
                                                        setDealers(tmpDealers);
                                                        searchDmsForm.setValue('dealers', []);
                                                        onChange( value);
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`sapId`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.dmsSapId')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name={"currentAttribute"}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.currentAttribute')}
                                        fullWidth
                                        options={curAttributes}

                                        getOptionLabel={(option: any) => option ? t(`searchDms.form.label.currentAttributeValue.${option}`) : ''}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`region`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.region')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`province`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.province')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`city`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.city')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`address`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.address')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`streetNumber`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.streetNumber')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name={"serviceType"}
                                        control={searchDmsForm.control}
                                        multiple
                                        label={t('searchDms.form.label.serviceType')}
                                        fullWidth
                                        options={serviceTypeList}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        getOptionLabel={(option) => option ? option : ''}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`chargingColumnId`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.chargingColumnId')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name={"chargingStationStatus"}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.chargingStationStatus')}
                                        fullWidth
                                        options={CHARGING_STATION_STATUS}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        getOptionLabel={(option) => option ? t(`searchDms.form.label.chargingStationStatusValue.${option}`) : ''}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name={`certificationProtocolIdentifyingCode`}
                                        control={searchDmsForm.control}
                                        label={t('searchDms.form.label.certificationProtocolId')}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3} sx={{display: "flex", alignItems: 'flex-end'}}>
                                    <FormAutocomplete
                                        name={"isKeyless"}
                                        label={t('searchDms.form.label.dmsKeyless')}
                                        options={isKeylessOptions}
                                        getOptionLabel={(option) => option ? t(`searchDms.form.label.keylessTypeValue.${option}`) : ''}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        defaultValue={undefined}
                                        //onChange={filtersStatus.handleChange}
                                        fullWidth
                                        control={searchDmsForm.control}
                                        />

{/*
                             <Grid item xs={6} md={3} sx={{display: "flex", alignItems: 'flex-end'}}>
                                  <Controller
                                        control={searchDmsForm.control}
                                        name={"keyless"}
                                        render={({field}) => (
                                            <FormControlLabel sx={{my: "auto"}}
                                                              control={
                                                                  <Switch checked={field.value} sx={{marginLeft: theme.spacing(1)}}
                                                                          onChange={(e) => {
                                                                              field.onChange(e);
                                                                          }}
                                                                          name="keyless"/>
                                                              }
                                                              label={t('searchDms.form.label.keyless')}
                                                              labelPlacement="start"
                                            />
                                        )}
*/}


                                </Grid>

                            </Grid>
                        }
                </form>
            </FormProvider>
        </Paper>
    )
}

export default DmsFilter;
